<template>
  <div>
    <b-col>
      <b-row>
        <b-col>
          <h2>Sperrfunktionen</h2>
        </b-col>
        <b-col class="p-1">
          <b-button size="sm" v-model='modalCreateState' id='modal-blocker-function-create' v-b-modal.modal-blocker-function-create variant="primary" @click="clearSelectedBlockerFunction()" class="m-2 float-right">Regel hinzufügen</b-button>
        </b-col>
      </b-row>
    </b-col>

    <b-row v-if="!finishedLoading" align-v="center" class="m-4 p-2">
      <b-col/>
      <b-col align-h="center">
        <div ><b-spinner style="width: 4rem; height: 4rem;" label="loading..."/></div>
      </b-col>
      <b-col/>
    </b-row>

    <b-table 
        v-else 
        striped 
        hover 
        size="sm"
        class="table-sm"
        :fields="fields" 
        :items="blockerFunctions"
    ><!-- table -->
      <template v-slot:cell(message)="row">
        <span v-if="row.item.processingRequest" class="text-success float-right">
            <b>Anfrage läuft</b>
        </span>
        <div v-else>
          <!-- span v-if="row.item.blockerDeleted == true"                                                      class="float-right"            ><b>Blockers Function wurde gelöscht</b></span -->
          <span      v-if="row.item.evaluationJob != null && row.item.evaluationJob.state  == 'failed'"         class="text-danger float-right"><b>Auswertung der Sperre ist fehlgeschlagen!</b> </span>
          <span v-else-if="row.item.evaluationJob != null && row.item.evaluationJob.state === 'mango_finished'" class="float-right"            >Mango-Queries fertig...</span>
          <span v-else-if="row.item.evaluationJob != null && row.item.evaluationJob.state === 'created'"        class="float-right"            >Sperre wird ausgewertet...</span>
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <div v-if="row.item.processingRequest"></div>
        <div v-else-if="row.item.evaluationJob != null && row.item.evaluationJob != undefined && row.item.evaluationJob.state === 'failed'"></div>
        <b-row class="float-right mr-1" v-else-if="row.item.evaluationJob == null || row.item.evaluationJob == undefined || row.item.evaluationJob.state === 'finished'">
          <b-button size="sm" v-b-modal.modal-blocker-function-edit variant="primary" @click="edit(row)" class="mr-1">
            <span class="icon icon-pencil"/>
          </b-button>

          <b-button class="mr-1" size="sm" variant="secondary"  v-b-modal.modal-product-list @click="modalProductList.open(row.item.id)">
            <span class="icon icon-search"/>
          </b-button>

          <b-button size="sm" variant="secondary" v-b-modal.modal-product-list @click="modalDelete.open(row.item.id)"> <span class="icon icon-bin"/> </b-button>
        </b-row>
        <b-col v-else>
          <div class="float-right mr-1"><b-spinner class="mr-2 pr-1" style="width: 1rem; height: 1rem;" label="loading..."/></div>
        </b-col>
      </template>

      <template v-slot:cell(blackOrWhite)="row">
        <b-row>
        <b-col>
        <span v-if="row.item.blackOrWhite" class="text-danger">Sperrung</span>
        <span v-else class="text-success">Freigabe</span>
        </b-col>

      </b-row>
      </template>
      <template v-if="finishedLoading" v-slot:cell(place)="row">
        <span v-if="row.item.countryId">Land <b>{{countries.find( country => country.id === row.item.countryId).name }}</b></span>
        <span v-else-if="row.item.marketId">Markt <b>{{markets.find( market => market.id === row.item.marketId).name }}</b></span>
        <span v-else-if="row.item.regionId">Region <b>{{regions.find( region => region.id === row.item.regionId).name }}</b></span>
      </template>
    </b-table>
      <!-- @ok="$bvModal.show('modal-blocker-function-edit')" -->
    <b-modal
      id="modal-blocker-function-create"
      title="Neue Regel Erstellen"
      cancel-title="Abbrechen"
      @ok="() => {show_modalBlockerFunctionEdit = true; }"
      no-close-on-backdrop
      centered
      size="md"
    ><!-- modal -->
      <b-input-group>
        <b-input-group-prepend>
          <b-form-select
              v-model="selectedBlockerFunction.type"
              :options="typeOptions"
          ></b-form-select>
        </b-input-group-prepend>
        <b-form-input v-model="selectedBlockerFunction.name"/>
        <b-input-group-append>
          <b-button 
          @click="selectedBlockerFunction.blackOrWhite = !selectedBlockerFunction.blackOrWhite"
          variant="outline-primary"
          ><!-- button -->
            <span v-if="selectedBlockerFunction.blackOrWhite" class="text-danger">Sperrung</span>
            <span v-else class="text-success">Freigabe</span>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>
    <b-modal id="modal-blocker-function-edit"
             v-model="show_modalBlockerFunctionEdit"
             @ok="saveBlockerFunction"
             cancel-title="Abbrechen"
             no-close-on-backdrop
             centered
             size="xl"
    ><!-- b-modal -->


      <template v-slot:modal-title>
        <b-row>
          <b-input-group class="mx-3">
            <b-input-group-prepend>
              <b-button
                disabled
              ><!-- button -->
                {{selectedBlockerFunction.type }}
              </b-button>
            </b-input-group-prepend>
            <b-form-input v-model="selectedBlockerFunction.name"/>
            <b-input-group-append>
              <b-button
                @click="selectedBlockerFunction.blackOrWhite = !selectedBlockerFunction.blackOrWhite"
                variant="outline-primary"
              ><!-- button -->
                <span v-if="selectedBlockerFunction.blackOrWhite" class="text-danger">Sperrung</span>
                <span v-else class="text-success">Freigabe</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-row>
      </template>
      <b-row>
        <b-col cols="2">
          <b-form-checkbox
          v-model="selectedBlockerFunction.isMarketplaceBlocker"
          :checked="true"
          :unchecked-value="false">
            <span>marktplatzbasierte Sperrung</span>
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-radio-group
              id="btn-radios-1"
              v-model="selectedBlockerFunction.place"
              :options="placeOptions"
              buttons
              button-variant="outline-primary"
              name="radios-btn-default"
              :disabled="selectedBlockerFunction.isMarketplaceBlocker"
          ></b-form-radio-group>
        </b-col>
        <b-col>
          <b-form-select
              v-if="selectedBlockerFunction.place === 'Land'"
              v-model="selectedBlockerFunction.countryId"
              :options="countrySelectOptions"
          />
          <b-form-select
              v-else-if="selectedBlockerFunction.place === 'Markt'"
              v-model="selectedBlockerFunction.marketId"
              :options="marketSelectOptions"
          />
          <b-form-select
              v-else-if="selectedBlockerFunction.place === 'Region'"
              v-model="selectedBlockerFunction.regionId"
              :options="regionSelectOptions"
          />
          <span v-else>Wählen Sie Land, Markt oder Region aus.</span>
        </b-col>

      </b-row>
      <hr>
      <span>Beschreibung:</span>
      <b-form-textarea v-model="selectedBlockerFunction.description" rows="3"/>
      <hr>
      <span v-if="selectedBlockerFunction.type === 'Funktion'">JavaScript Funktion:</span>
      <span v-else-if="selectedBlockerFunction.type === 'Wortliste'">Wort Regel Liste:</span>
      <span v-else-if="selectedBlockerFunction.type === 'Barcodestamm'">EAN Stamm:</span>
      <span v-else>payload:</span>
      <div v-if="selectedBlockerFunction.type === 'Wortliste'">
        <blocker-function-editor
          ref="blocker_function_editor"
          v-model="selectedBlockerFunctionPayload"
          v-if="selectedBlockerFunction.type === 'Wortliste'"
        />
          <div class="m-2">
              <span>Jedes Wort in jeder Zeile werden verundet.</span>
              <br>
              <span>Jede Reihe wird verodert.</span>
              <br>
              <span>Beispiel: ([Hewlett] <b>und</b> [Packard]) <b>oder</b> ([Nintendo] <b>und</b> [Wii])</span>
              <br>
              <span>Alle Artikel mit entweder der Wortkombination "Hewlett" und "Packard" oder der Kombination "Nintendo" und "Wii" werden ausgewählt.</span>
          </div>
      </div>
      <b-form-input
        v-else-if="selectedBlockerFunction.type === 'Barcodestamm'"
        v-model="selectedBlockerFunction.payload"
      />
      <b-form-textarea
        v-else
        v-model="selectedBlockerFunction.payload"
        @focus.native="$event.target.select()"
        rows="15"
      />
    </b-modal>
    <div v-if="modalProductList.blockerFunction">
    <b-modal
      id="modal-product-list"
      :title="modalProductList.generateTitle()"
      size="xl"
      v-model="modalProductList.state"
      centered
      @hidden="modalProductList.close()"
    >
        <b-row v-if="!modalProductList.productAsins" align-v="center" class="m-4 p-2">
            <b-col/>
            <b-col align-h="center">
                <div><b-spinner style="width: 4rem; height: 4rem;" label="loading..."/></div>
            </b-col>
            <b-col/>
        </b-row>
        <div v-else>
            <div class="overflow-auto">
                <b-pagination
                    v-if="modalProductList.productAsins"
                    v-model="modalProductList.currentPage"
                    :total-rows="modalProductList.productAsins.length"
                    :per-page="modalProductList.perPage"
                    aria-controls="table-product-list"
                ></b-pagination>
                <b-table
                    id="table-product-list"
                    :items="modalProductList.productAsins"
                    :per-page="modalProductList.perPage"
                    :current-page="modalProductList.currentPage"
                    :fields="modalProductList.fields"
                    small
                >
                    <template v-slot:cell(name)="row">
                        <span style="color:gray">{{row.item.name}}</span>
                    </template>
                    <template v-slot:cell(asin)="row">
                      <b style="font-family:'Lucida Console', monospace">{{row.item.asin}}</b>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-button @click="openMaterialInterface(row.item.asin)"><span class="icon icon-newspaper"></span></b-button>
                    </template>
                </b-table>
            </div>
        </div>
    </b-modal>
    </div>

    <b-modal 
        v-model="modalDelete.state"
        @ok="modalDelete.ok"
        @hidden="modalDelete.reset"
        centered
    >Wollen sie die Sperrung/Freigabe wirklich löschen?</b-modal>
  </div>
</template>
<script>
    import axios from 'axios';

    // import BlockerFunctionEditor from './BlockerFunctionEditor';
    export default {
      name: "BlockerFunction",
      data()
      {
        return {
          user: null,
          modalCreateState: false,
          show_modalBlockerFunctionEdit: false,
          timer: '',
          finishedLoading: false,
          blockerFunctions: [],
          countries: [],
          regions: [],
          markets: [],
          countrySelectOptions: [],
          regionSelectOptions: [],
          marketSelectOptions: [],
          fields: [
            { key: 'type',         label: 'Typ', sortable: true },
            { key: 'name',         label: 'Name', sortable: true},
            { key: 'blackOrWhite', label: 'Sperrung/Freigabe', sortable: true},
            { key: 'username',     label: 'Benutzer', sortable: true },
            { key: 'updatedAt',    label: 'geändert am', sortable: true , formatter: (s) => (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '-'},
            { key: 'place',        label: 'Region', sortable: true },
            { key: 'productCount', label: 'betroffene Artikel', sortable: true},
            { key: 'message',      label: ''},
            { key: 'actions',      label: ''}
          ],
          typeOptions: ['Barcodestamm', 'Wortliste', 'Funktion'],
          typeToGerman: function(label) {
              switch(label) {
                  case    'ean': return 'Barcodestamm';
                  case  'regex': return 'Wortliste';
                  case 'custom': return 'Funktion';
                  default: return label;
              }
          },
          typeToEnglish: function(label) {
            switch(label) {
              case 'Barcodestamm': return 'ean';
              case    'Wortliste': return 'regex';
              case     'Funktion': return 'custom';
              default: return label;
            }
          },
          placeOptions: [ "Markt", "Region", "Land" ],
          placeOptionsDisabled: false,
          selectedBlockerFunction: {
            name: "",
            type: undefined,
            place: null,
            description: "",
            blackOrWhite: 1,
            username: null,
            countryId: undefined,
            marketId: undefined,
            regionId: undefined,
            isMarketplaceBlocker: false
          },
          modalProductList: {
            state: false,
            blockerFunction: null,
            productAsins: null,
            fields: [
              { key: 'asin', label: 'ASIN'},
              { key: 'name', label: 'Name'},
              { key: 'actions', label: '' }
            ],
            perPage: 10,
            currentPage: 1,
            open: (id) => {
              this.modalProductList.blockerFunction = this.blockerFunctions.find( bf => bf.id == id );
              axios.get(`mds/blocker_function_product/by_blocker_function_with_asin/${id}`).then( response => {
                  this.modalProductList.productAsins = response.data;
                  this.modalProductList.state = true;
              }).catch( error => {
                  console.log(error);
              });
            },
            close: () => {
              this.modalProductList.blockerFunction = null,
              this.modalProductList.productAsins = null
            },
            generateTitle: () => {
               return 'betroffene Artikel des Blockers »' + this.modalProductList.blockerFunction.name + '«';
            }
          },
          modalDelete: {
            state: false,
            blockerFunctionId: null,
            open: (id) => {
              this.modalDelete.blockerFunctionId = id;
              this.modalDelete.state = true;
            },
            ok: () => {
              this.blockerFunctions.find( bf => bf.id == this.modalDelete.blockerFunctionId ).processinRequest = true;
              axios.delete(`/mds/blocker_function/${this.modalDelete.blockerFunctionId}`).then( response => {
                  this.modalDelete.blockerFunctionId = null;
                  alert(`Blocker Function wird gelöscht, dies kann mehrere Stunden in Anspruch nehmen.`); // TODO
              }).catch( error => {
                alert(`Löschvorgang ist fehlgeschlagen: \n ${JSON.stringify(error)}`); // TODO
                this.modalDelete.blockerFunctionId = null;
              });
            },
            reset: () => {
              this.modalDelete.blockerFunctionId = null;
            }
          },
            //for some reason, this prop cannot be inside of selectedBF, changes aren't handled correctly.
          selectedBlockerFunctionPayload: ''
        }
      },
      methods: {
        openMaterialInterface(asin)
        {
          let urlDump2 = '/material/by_asin/' + asin
          axios.get(urlDump2).then( response => {
              let urlDump = `/material/${response.data.id}/edit`;
              var win = window.open(urlDump, "_blank");
              win.focus();
          });
        },
        fetchData()
        {
          axios.get('/mds/evaluation_job').then( response => {
            this.blockerFunctions = this.blockerFunctions.map( bf => {
              let many = response.data.filter( ej => {
                return ej.blockerFunctionId === bf.id;
              }).sort((a,b) => { return a.id <= b.id });
              bf.evaluationJob = (many.length > 0) ? many[many.length - 1] : null;
              bf.processingRequest = false;
              //if(many.length == 0) bf.blockerDeleted = true;
              return bf;
            });

          }).catch( error => { console.log(error) });
        },
        clearSelectedBlockerFunction() {
          this.selectedBlockerFunction = {
            name: "",
            type: null,
            description: "",
            blackOrWhite: 1,
            countryId: undefined,
            marketId: undefined,
            regionId: undefined,
            place: null,
            isMarketplaceBlocker: false
          };
          this.selectedBlockerFunctionPayload = null;
        },
        edit(row)
        {
          this.selectedBlockerFunction = row.item;

          //copy payload if we are type.regex (so that it can be properly emitted. Vue can't handle nested props very well).
          if(this.selectedBlockerFunction.type === 'Wortliste')
          {
            this.selectedBlockerFunctionPayload = this.selectedBlockerFunction.payload;
          }

          //choose place based on if country,region or marketId are set:
          if(this.selectedBlockerFunction.countryId)
          {
            this.selectedBlockerFunction.place = 'Land';
          }
          else if(this.selectedBlockerFunction.marketId)
          {
            this.selectedBlockerFunction.place = 'Markt';
          }
          else if(this.selectedBlockerFunction.regionId)
          {
            this.selectedBlockerFunction.place = 'Region';
          }
        },
        saveBlockerFunction(evt)
        {
            // if we are dealing with type.regex, then we need to copy selectedBlockerFunctionPayload

            if(this.selectedBlockerFunction.type === 'Wortliste')
            {
              this.$refs.blocker_function_editor.exportRuleSet();
              this.selectedBlockerFunction.payload = this.selectedBlockerFunctionPayload;
            }
            else if( ['Barcodestamm', 'asin'].includes(this.selectedBlockerFunction.type))
            {
              if(this.selectedBlockerFunction.payload.match(/^[0-9,a-z,A-Z,\n]+$/) == null)
              {
                  evt.preventDefault();
                  alert("invalid input");
                  return;
              }
              // convert the payload to json-string, remove empty strings.
              // blocker function ean is only a single root ean, not a list.
              //this.selectedBlockerFunction.payload = JSON.stringify(this.selectedBlockerFunction.payload.split('\n').filter( x => x.length !== 0 ));
            }

            // this code block guarantees that we only set a single place id.sss
            if(this.selectedBlockerFunction.place === null && !this.selectedBlockerFunction.isMarketplaceBlocker) {
                 alert('Kein Land, Markt oder Region wurde ausgewählt.');
                 evt.preventDefault();
                 show_modalBlockerFunctionEdit = true;
                 return;

            }else if(this.selectedBlockerFunction.place === null && this.selectedBlockerFunction.isMarketplaceBlocker){
              this.selectedBlockerFunction.marketId = null;
              this.selectedBlockerFunction.regionId = null;
              this.selectedBlockerFunction.countryId = null;
              this.selectedBlockerFunction.isMarketplaceBlocker = true;

            }else if (this.selectedBlockerFunction.place === 'Land') {
                this.selectedBlockerFunction.marketId = null;
                delete this.selectedBlockerFunction.marketId;
                this.selectedBlockerFunction.regionId = null;
                delete this.selectedBlockerFunction.regionId;
                if(!this.selectedBlockerFunction.countryId) {
                  alert('Kein Land wurde ausgewählt.');
                  evt.preventDefault();
                  show_modalBlockerFunctionEdit = true;
                  return;
                }
            }else if (this.selectedBlockerFunction.place === 'Markt') {
                this.selectedBlockerFunction.countryId = null;
                delete this.selectedBlockerFunction.countryId;
                this.selectedBlockerFunction.regionId = null;
                delete this.selectedBlockerFunction.regionId;
                if(!this.selectedBlockerFunction.marketId) {
                  alert('Kein Markt wurde ausgewählt.');
                  evt.preventDefault();
                  show_modalBlockerFunctionEdit = true;
                  return;
                }
            }else if (this.selectedBlockerFunction.place === 'Region') {
                this.selectedBlockerFunction.countryId = null;
                delete this.selectedBlockerFunction.countryId;
                this.selectedBlockerFunction.marketId = null;
                delete this.selectedBlockerFunction.marketId;
                if(!this.selectedBlockerFunction.regionId) {
                  alert('Keine Region ausgewählt.');
                  evt.preventDefault();
                  show_modalBlockerFunctionEdit = true;
                  return;
                }
            } else {
                alert('no place selected. Aborting save.');
                evt.preventDefault();
                show_modalBlockerFunctionEdit = true;
                return;
            }
            //copy object because of the translation mess.
            this.selectedBlockerFunction.processingRequest = true;
            this.selectedBlockerFunction.username = this.user.name;
            let clone = _.cloneDeep(this.selectedBlockerFunction);
            clone.type = this.typeToEnglish( this.selectedBlockerFunction.type );
            if (this.selectedBlockerFunction.id)
            {
                this.blockerFunctions.find( x => x.id == this.selectedBlockerFunction.id).processingRequest = true;
                axios.put('/mds/blocker_function', clone ).then( () => {
                  this.clearSelectedBlockerFunction();
                }).catch(error => { console.log(error) });
            }
            else
            {
              //evt.preventDefault();
              axios.post(`/mds/blocker_function`, clone ).then( response =>
              {
                response.data.type = this.typeToEnglish(response.data.type);
                this.blockerFunctions.push(response.data.blockerFunction);
                this.clearSelectedBlockerFunction();
                this.$bvModal.hide('modal-blocker-function-create');
                this.modalCreateState = false;
              }).catch( error => {
                console.log(error)
                alert('Der Speichervorgang ist fehlgeschlagen.');
                  evt.preventDefault();
                  //this.modalCreateState = true;
                  this.show_modalBlockerFunctionEdit = true;
              });
            }
        }
      },
      mounted() {
          Promise.all( [
                '/mds/blocker_function_with_product_count'
                , '/mds/country'
                , '/mds/market'
                , '/mds/region'
                , '/mds/evaluation_job'
                , '/user/self'
              ].map(s => axios.get(s))
          ).then( ([blockerFunctions, countries, markets, regions, evaluationJobs, _user]) => {
                this.finishedLoading = true;
                this.blockerFunctions = blockerFunctions.data.map( bf => {
                      bf.type = this.typeToGerman(bf.type); //TODO this is stupid doing it like this. BoostrapVue has label/Value syntax for this.
                      //bf.evaluationJobs = evaluationJobs.data.filter( ej => ej.blockerFunctionId === bf.id );
                      bf.evaluationJob = evaluationJobs.data.filter( ej => ej.blockerFunctionId === bf.id ).sort((a, b) => { return a.id >= b.id });
                      bf.evaluationJob = (bf.evaluationJob.length > 0) ? bf.evaluationJob[bf.evaluationJob.length - 1] : null;
                      return bf;
                    }
                );
                this.timer = setInterval(this.fetchData, 4000);
                this.countries = countries.data;
                this.markets = markets.data;
                this.regions = regions.data;
                this.user = _user.data;
                this.marketSelectOptions = this.markets.map( x => {
                  return {
                      value: x.id,
                      text: x.name
                  }});

              this.countrySelectOptions = this.countries.map( x => {
                return {
                    value: x.id,
                    text: x.name
                }});

              this.regionSelectOptions = this.regions.map( x => {
                  return {
                      value: x.id,
                      text: x.name
                  }
              });
            })
          .catch( error => console.log(error) );
      },
      beforeDestroy () {
        clearInterval(this.timer);
      }
    }
</script>

